export default __webpack_public_path__ + "static/dsw_logo-dark-19f4c8cd249205801119dfa85e3d5ec1.png";